import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { RequestOptions, Headers } from '@angular/http';
import { IRequestOptions } from './easy-marine-http-finances';

export function easyMarineHttpClientCreator(http: HttpClient, router: Router) {
    // tslint:disable-next-line: no-use-before-declare
    return new EasyMarineHttpClient(http, router);
}

@Injectable()
export class EasyMarineHttpClient {

    // Extending the HttpClient through the Angular DI.
    public constructor(private http: HttpClient, private router: Router) {
    }

    /**
     * GET request
     * @param endPoint it doesn't need / in front of the end point
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public get<T>(endPoint: string, options?: IRequestOptions, marinaId?: number): Observable<T> {
        const ops = this.createRequestOptions(options, marinaId);
        return this.http.get<T>(endPoint, ops);
    }

    /**
     * POST request
     * @param endPoint end point of the api
     * @param params body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public post<T>(endPoint: string, params: object, options?: IRequestOptions): Observable<T> {
        return this.http.post<T>(endPoint, params, this.createRequestOptions(options));
    }

    /**
     * PUT request
     * @param endPoint end point of the api
     * @param params body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public put<T>(endPoint: string, params: object, options?: IRequestOptions): Observable<T> {
        return this.http.put<T>(endPoint, params, this.createRequestOptions(options));
    }

    /**
     * DELETE request
     * @param endPoint end point of the api
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public delete<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
        return this.http.delete<T>(endPoint, this.createRequestOptions(options));
    }

    private createRequestOptions(options?: IRequestOptions, marinaId?: number): IRequestOptions {
        let headers: any;
        if (options && options.headers) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders();
        }

        if(marinaId){
            headers = headers.set('MarinaId', marinaId.toString());
        }

        headers = headers.set('Accept', 'application/json');
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            headers = headers.set('Authorization', 'Bearer ' + currentUser.token);
            headers = headers.set('UserId', currentUser.id.toString());
            headers = headers.set('OriginEasy', 'EasyAdmin')
            headers = headers.set('refreshToken', localStorage.getItem('refreshToken'))
        }
        return {
            ...options,
            headers
        };
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_utils/easy-marine-http-client.ts